import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';

declare var ko: any;

export class initiativeModelReport_template extends vnTemplate{

    public brandsFilter: filterDropdown_template;
    public startMonthFilter: filterSingleDate_template;
    public endMonthFilter: filterSingleDate_template;
    public validationsList: validationsList_template;

    protected getTemplateHtml(): string{

        return `

                <div class="sub-header header-model-report-page"  id="sub-filters">
                    
                    <div class="w-justify margin-bottom">
                        <div class="w-left">
                            <div><label class="form-label" for="" >Brands</label> ${ this.brandsFilter.getHtmlBuild() }</div>
                            <div class="no-margin"><label class="form-label" for="" >Starting Month</label> ${ this.startMonthFilter.getHtmlBuild() }</div>
                            <div><label class="form-label" for="" >Ending Month</label> ${ this.endMonthFilter.getHtmlBuild() }</div>
                        </div>
                    </div>
                    
                    <div class="w-justify">
                       <div class="w-left">
                           <label class="group-label icon i-label">Initiatives</label>
                           <div data-bind="foreach: initiatives">
                               <button class="btn" data-bind="text: name, css: {'is-selected': ($parent.selectedInitiative().id == id)}, event: { click: $parent.onClickInitiativeButton}"/>
                           </div>
                        </div>
                        <div class="w-right"> 
                           <label class="group-label icon i-group">Network Category Groups</label>
                           <div data-bind="foreach: groups">
                               <button class="btn" data-bind="text: name, css: {'is-selected': ($parent.selectedGroup().id == id)}, event: { click: $parent.onClickGroupButton}"/>
                           </div>
                        </div>
                    </div>
                    
                </div>
                <!-- ko if: costAllocations().length !== 0 -->
                <div id="list-results-cost-allocations">
                    <table class="list-results width-auto">
                        <thead>
                            <th><span>name</span></th>
                            <th><span>amount</span></th>
                            <th><span>nbr of Articles</span></th> 
                        </thead>
                        <tbody data-bind="foreach: costAllocations">
                            <td ><span data-bind="text: name"></span></td>
                            <td class="align-right"><span data-bind="text: '$' + amount"></span></td>
                            <td class="align-right"><span data-bind="text: nbrArticles"></span></td>  
                        </tbody>
                    </table>
                </div>
                <!-- /ko -->

                <div class="w-list-results list-model-report-page"  id="list-results">
                    <table class="list-results list-sections">
                        <thead class="list-header-section">      
                            <tr>
                                <th colspan="11">
                                    <div class="flex">
                                        <span class="icon i-label margin" data-bind="text: 'initiative: ' + selectedInitiative().name"></span> <br>
                                        <span class="icon i-group" data-bind="text: 'network category group: ' + selectedGroup().name"></span>
                                    </div>
                                </th>
                            </tr>              
                            <tr>
                                <th colspan="1" class="no-shadow align-left"></th>
                                <th colspan="4" class="section-1"><span>Costs</span></th>
                                <th colspan="3" class="section-2"><span>Performances</span></th>
                                <th colspan="1" class="section-3"></th>
                            </tr>
                            <tr>
                                <input data-bind="value: orderBy" type="hidden">
                                <input data-bind="value: orderByDirection" type="hidden">
                                <th class="no-shadow"><span data-bind="event: { click: onClickReorder.bind($data, 'yearMonth') }, css: { 'list-sort-desc': orderByAndDirection()=='yearMonth_DESC', 'list-sort-asc': orderByAndDirection()=='yearMonth_ASC' }" class="icon list-sort-none">Month</span></th>
                                <th class="section-1 "><span>Articles</span></th>
                                <th class="section-1 "><span>Articles/Day</span></th>
                                <th class="section-1"><span>Cost/Article</span></th>
                                <th class="section-1 "><span class="total">Total Cost</span></th>
                                <th class="section-2 "><span>Sessions/Article</span></th>
                                <th class="section-2 "><span>Sessions</span></th>
                                <th class="section-2 "><span>SV</span></th>
                                <th class="section-3 "><span>Adj. Revenue</span></th>
                                
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: report">        
                            <tr data-bind="css:  {'section-2': (type == 'Historical'), 'section-2': (type == 'Projection'), 'is-selected' : isRowSelected, 'first' : isFirstProjection }, event: { click: $parent.onClickShowCostAllocation}">
                                
                                <td class="border-right"><span data-bind="text: date"></span></td>
                                
                                <td class="">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical')  && diff_nbrArticles !== null --> 
                                        <span data-bind="text: Number(projected_nbrArticles).toLocaleString('en-us')"></span>
                                        <!-- /ko -->
                                        <span data-bind="text: Number(nbrArticles).toLocaleString('en-us'), class: diff_nbrArticles_className"></span>
                                        
                                    </div> 
                                </td>
                                
                                <td class="">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') &&  diff_articlePerDay !== null --> 
                                        <span data-bind="text: Number(projected_articlePerDay).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        <!-- /ko -->
                                        <span data-bind="text: Number(articlePerDay).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}), class: diff_articlePerDay_className"></span>
                                        
                                    </div>
                                </td>
                                
                                <td class="border-right">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') && diff_costPerArticle !== null --> 
                                        <span data-bind="text: '$' + Number(projected_costPerArticle).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                        <!-- /ko -->
                                        <span class="invert" data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}), class: diff_costPerArticle_className"></span>
                                        
                                    </div> 
                                </td>
                                
                                <td class="border-right">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') &&  diff_totalCost !== null --> 
                                        <span class="total" data-bind="text:'$' + Number(projected_totalCost).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>                                   
                                        <!-- /ko -->
                                        <span class="invert" data-bind="text: '$' + Number(totalCost).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}), class: diff_totalCost_className"></span>
                                        
                                    </div>
                                </td>

                                <td class="">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') &&  diff_sessionsPerArticle !== null --> 
                                        <span data-bind="text: Number(projected_sessionsPerArticle).toLocaleString('en-us')"></span>
                                        <!-- /ko -->
                                        <span data-bind="text: Number(sessionsPerArticle).toLocaleString('en-us'), class: diff_sessionsPerArticle_className"></span>
                                        
                                    </div>
                                </td>
                                
                                
                                <td class="">
                                    <div class="flex"> 
                                        <!-- ko if: (type == 'Historical') &&  diff_sessions !== null -->
                                        <span data-bind="text: Number(projected_sessions).toLocaleString('en-us')"></span>
                                        <!-- /ko -->
                                        <span data-bind="text: Number(sessions).toLocaleString('en-us'), class: diff_sessions_className"></span>
                                          
                                    </div>
                                </td>
                                
                                <td class="border-right">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') &&  diff_sessionValue !== null --> 
                                        <span data-bind="text: '$' + Number(projected_sessionValue).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>                                    
                                        <!-- /ko -->
                                        <span data-bind="text: '$' + Number(sessionValue).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}), class: diff_sessionValue_className"></span>
                                        
                                    </div>
                                </td>
                                
                                <td class="border-right">
                                    <div class="flex">
                                        <!-- ko if: (type == 'Historical') &&  diff_adjRevenue !== null -->  
                                        <span data-bind="text: '$' + Number(projected_adjRevenue).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>                                    
                                        <!-- /ko -->          
                                        <span data-bind="text: '$' + Number(adjRevenue).toLocaleString('en-us', {minimumFractionDigits: 2, maximumFractionDigits: 2}), class: diff_adjRevenue_className"></span>
                                        
                                    </div>
                                </td>
                                
                                
                            </tr> 
                            <!--
                            <tr class="stroke">
                                <td colspan="11"></td>
                            </tr> 
                            -->        
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
            `;
    }

    protected initPartial(): void {

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.startMonthFilter = new filterSingleDate_template("startMonthsFilter", this.getTemplateViewModel(), this.caller);
        this.startMonthFilter.setDate(this.getFourMonthsPrior());

        this.endMonthFilter = new filterSingleDate_template("endMonthsFilter", this.getTemplateViewModel(), this.caller);
        this.endMonthFilter.setDate(this.getFourteenMonthsLater());
    }

    public getFourMonthsPrior(): string {
        let monthsList = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];
        let fourMonthPrior = new Date();
        fourMonthPrior.setMonth(fourMonthPrior.getMonth() - 4);
        let firstOfMonthStarting = new Date(fourMonthPrior.getFullYear(), fourMonthPrior.getMonth(), 1);

        return firstOfMonthStarting.getFullYear() + '/' + monthsList[firstOfMonthStarting.getMonth()] + '/' + firstOfMonthStarting.getDate();
    }

    public getFourteenMonthsLater(): string {
        let monthsList = [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
        ];

        let fourteenMonthPrior = new Date();
        fourteenMonthPrior.setMonth(fourteenMonthPrior.getMonth() + 12);
        let firstOfMonthEnding = new Date(fourteenMonthPrior.getFullYear(), fourteenMonthPrior.getMonth() + 1, 0);

        return firstOfMonthEnding.getFullYear() + '/' + monthsList[firstOfMonthEnding.getMonth()] + '/' + firstOfMonthEnding.getDate();
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.startMonthFilter.buildCalendarWithoutTime();
        this.endMonthFilter.buildCalendarWithoutTime();
    }

    protected getTemplateName(): string{

        return "initiativeModelReport-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

    	return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            orderBy: ko.observable("yearMonth"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("yearMonth_ASC"),
            report: ko.observableArray([]),
            groups: ko.observableArray([]),
            initiatives: ko.observableArray([]),
            selectedGroup: ko.observable({id:0, name: 'all'}),
            selectedInitiative: ko.observable({id:0, name: 'all'}),
            costAllocations: ko.observableArray([]),
            reportTitle: ko.observable(''),
            isLoading: ko.observable(false),
            onClickGroupButton: function (data, event) {
                self.onClickGroupButton(data);
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickInitiativeButton: function (data, event) {
                self.onClickInitiativeButton(data);
            },
            onClickShowCostAllocation: function (data, event) {
                self.onClickShowCostAllocation(data);
            },

        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        let currentDate = new Date();

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            brandId: this.brandsFilter.getTemplateViewModel().selectedOption,
            groupId: this.getTemplateViewModel().selectedGroup().id,
            initiativeId: this.getTemplateViewModel().selectedInitiative().id,
            startDate: this.startMonthFilter.getTemplateViewModel().singleDatePicker,
            endDate: this.endMonthFilter.getTemplateViewModel().singleDatePicker
        }
    }

    public resetOrderParameters(): void {
        this.getTemplateViewModel().orderBy('');
        this.getTemplateViewModel().orderByDirection('');
        this.getTemplateViewModel().orderByAndDirection('');
    }


    /**
     *
     * @param value
     * @param data
     * @param event
     */
    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.reportDataReorder();
    }


    protected onClickGroupButton(group: {id: number, name: string}): void {

        this.getTemplateViewModel().selectedGroup(group);
        this.caller.getListData();
    }


    protected onClickInitiativeButton(initiative: {id: number, name: string}): void {

        this.getTemplateViewModel().selectedInitiative(initiative);
        this.caller.getListData();
    }

    protected onClickShowCostAllocation(data): void {

        this.getTemplateViewModel().costAllocations([]);

        let selectedInitiativeName = this.getTemplateViewModel().selectedInitiative().name;
        let selectedCategoryGroupName = this.getTemplateViewModel().selectedGroup().name;

        this.unselectAllRows();


        if(['all', 'others'].indexOf(selectedInitiativeName) == -1 && ['all', 'others'].indexOf(selectedCategoryGroupName) == -1 && data.type == 'Projection'){

            this.displayCostAllocation(data);
        }
    }



    public resetSubFilters(): void {
        this.getTemplateViewModel().selectedInitiative({id:0, name: 'all'});
        this.getTemplateViewModel().selectedGroup({id:0, name: 'all'});
    }

    public setReportData(reportData): void{

        let isFirstProjectionFound = false;

        for(let reportRow of reportData){

            reportRow['isRowSelected'] = ko.observable(false);
            reportRow['isFirstProjection'] = ko.observable(false);

            if(!isFirstProjectionFound && reportRow.type == 'Projection') {

                reportRow['isFirstProjection'] = ko.observable(true);
                isFirstProjectionFound = true;

            }

            this.setDiffClasses(reportRow);

        }



        this.getTemplateViewModel().report(reportData);

        console.log(this.getTemplateViewModel().report());
    }

    public setBrandsFilterItems(brands:  Array<{id: number,  name: string}>): void {
        this.brandsFilter.setOptions(brands);
    }

    public setInitiativesFilterItems(initiatives: Array<{id: number, initiative: string, name: string}>): void {

        initiatives.unshift({id: 0, initiative: 'all', name: 'all'});
        initiatives.push({id: -1, initiative: 'others', name: 'others'})
        this.getTemplateViewModel().initiatives(initiatives);
    }

    public setGroupsFilterItems(groups: Array<{id: number,  name: string}>): void {

        groups.unshift({id: 0, name: 'all'});
        groups.push({id: -1, name: 'others'})
        this.getTemplateViewModel().groups(groups);
    }

    public displayCostAllocation(data){

        data.isRowSelected(true);

        this.caller.getCostAllocationData(data.month, data.year);

    }

    private unselectAllRows(){

        let reportRows = this.getTemplateViewModel().report();

        for(let reportRow of reportRows){
            reportRow.isRowSelected(false);
        }
    }

    private setDiffClasses(rowData){

        this.setClassForData(rowData, rowData['diff_adjRevenue'], 'diff_adjRevenue');
        this.setClassForData(rowData, rowData['diff_articlePerDay'], 'diff_articlePerDay');
        this.setClassForData(rowData, rowData['diff_costPerArticle'], 'diff_costPerArticle');
        this.setClassForData(rowData, rowData['diff_nbrArticles'], 'diff_nbrArticles');
        this.setClassForData(rowData, rowData['diff_profit'], 'diff_profit');
        this.setClassForData(rowData, rowData['diff_sessionValue'], 'diff_sessionValue');
        this.setClassForData(rowData, rowData['diff_sessions'], 'diff_sessions');
        this.setClassForData(rowData, rowData['diff_sessionsPerArticle'], 'diff_sessionsPerArticle');
        this.setClassForData(rowData, rowData['diff_totalCost'], 'diff_totalCost');

        console.log(this.getTemplateViewModel().report());

    }

    private setClassForData(dataList, data, dataName){

        let className = '';

        if(dataList['type'] == 'Historical' && data != null) {

            if (data < 80) {

                className = 'diff-level-under-1';

            } else if (data >= 80 && data < 94) {

                className = 'diff-level-under-2';

            } else if (data >= 94 && data < 99) {

                className = 'diff-level-under-3';

            } else if (data >= 99 && data < 105) {

                className = 'diff-level-over-1';

            } else if (data >= 105 && data < 120) {

                className = 'diff-level-over-2';

            } else if (data >= 120) {

                className = 'diff-level-over-3';
            }
        }

        dataList[dataName+ '_className'] = className;

    }
}



// WEBPACK FOOTER //
// ./js/components/templates/initiativeModelReport_template.ts